import React, { useEffect, useState } from 'react';
import CreateReferral from './CreateReferral';
import ListReferral from './ListReferral';
import { ENUM_CUS_EVENT } from '../../../../enums/enums';
import CusPageContainer from '../../../../components/shared/CusPageContainer';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import useToast from '../../../../hooks/useToast';
import useGroupByGroupId from '../../../../hooks/site/useGroupByGroupId';
import { useAppSelector } from '../../../../store';
import { API_GROUP } from '../../../../api/user';
import { useDispatch } from 'react-redux';
import { setRefLinks } from '../../../../store/apps/groupInfoSlice';
import { dispatchCusEvent } from '../../../../utils';
import ErrorBoundary from '../../../../components/material-ui/error_boundary/ErrorBoundary';

export default function ReferralLink() {
  const { group, groupId } = useGroupByGroupId();
  const refLinks = useAppSelector((state) => state.groupInfo.refLinks?.[groupId]) || [];
  const refLinksInfo = useAppSelector((state) => state.groupInfo.refLinksInfo?.[groupId]) || {};
  const [referrals, setReferral] = useState(refLinks);
  const { errorToast } = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatchCusEvent(ENUM_CUS_EVENT.getRefcodeList, { groupId });
  }, []);

  useEffect(() => {
    if (!refLinks || !refLinks.length) return;
    setReferral(refLinks.map((el) => ({ ...el, anchor: '' })));
  }, [refLinks]);

  const createReferralHandler = (comment, pbParams) => {
    API_GROUP.refCode
      .create({ groupId, comment, pbParams })
      .then((e) => {
        console.log(e);
        const data = e.data.data;
        const newStore = [data, ...refLinks];
        dispatch(setRefLinks({ groupId, data: newStore }));
      })
      .catch(console.log);
  };

  const deleteReferralHandler = (id) => {
    API_GROUP.refCode
      .delete({ refcodeId: id })
      .then(() => {
        setReferral((prev) => prev.filter((el) => el.id !== id));
      })
      .catch(console.log);
  };

  const getNewLink = (link, anchor, type) => {
    if (type == 'tg') {
      errorToast('Anchors can only be added to site links.');
      return link;
    }

    // const clearLink = link
    //   .replaceAll(ENUM_ANCHORS.signupDepositOn, '')
    //   .replaceAll(ENUM_ANCHORS.signupOn, '')
    //   .replaceAll(ENUM_ANCHORS.signup, '')
    //   .replaceAll(ENUM_ANCHORS.fortuneOn, '')
    //   .replaceAll(ENUM_ANCHORS.fortune, '');

    // return link.includes(anchor) ? clearLink : clearLink + anchor;
    return link.includes(anchor) ? '' : anchor;

    // if (link.includes(signup) && anchor.includes(signup)) {
    //   const newLink = link
    //     .replace(ENUM_ANCHORS.signupDepositOn, '')
    //     .replace(ENUM_ANCHORS.signupOn, '')
    //     .replace(ENUM_ANCHORS.signup, '');

    //   // если якорь сигнап и в текущей ссылке уже сигнапОН или сигнапДепозит то очищенную ссылку + якорь
    //   if (
    //     (link.includes(ENUM_ANCHORS.signupOn) || link.includes(ENUM_ANCHORS.signupDepositOn)) &&
    //     anchor == signup
    //   )
    //     return newLink + anchor;

    //   // если есть включение выбранного в текущую ссылку, то очищенную иначе очищенную с якорем
    //   return link.includes(anchor) ? newLink : newLink + anchor;
    // }

    // if (link.includes(fortune) && anchor.includes(fortune)) {
    //   const newLink = link.replace(ENUM_ANCHORS.fortuneOn, '').replace(ENUM_ANCHORS.fortune, '');
    //   // если якорь фортуне и в текущей ссылке уже фортунеОН то очищенную ссылку + якорь
    //   if (link.includes(ENUM_ANCHORS.fortuneOn) && anchor == fortune) return newLink + anchor;

    //   // если есть включение выбранного в текущую ссылку, то очищенную иначе очищенную с якорем
    //   return link.includes(anchor) ? newLink : newLink + anchor;
    // }

    // return link + anchor;
  };

  const editAnchorHandler = (idReferral, anchor) => {
    if (!idReferral) return;

    setReferral((prev) => {
      const newReferral = [];
      for (let referral of prev) {
        if (referral.id === idReferral) {
          const link = referral.anchor || '';
          const newAnchor = getNewLink(link, anchor);
          newReferral.push({
            ...referral,
            anchor: newAnchor
          });
          continue;
        }
        newReferral.push(referral);
      }

      return newReferral;
    });
  };

  const onCommentChange = (refcodeId, comment, pbParams) => {
    return API_GROUP.refCode
      .update({ refcodeId, comment, pbParams })
      .then(() => {
        setReferral((prev) => {
          const newReferral = [];
          for (let referral of prev) {
            if (referral.id === refcodeId) {
              newReferral.push({ ...referral, comment, pbParams });
              continue;
            }
            newReferral.push(referral);
          }

          return newReferral;
        });
      })
      .catch(console.log);
  };

  return (
    <CusPageContainer title="Referral links" group={group} loader={!group}>
      <ErrorBoundary>
        <CreateReferral createReferralHandler={createReferralHandler} groupId={groupId} />
      </ErrorBoundary>
      <ShowContainer condition={referrals.length}>
        <ListReferral
          refLinksInfo={refLinksInfo}
          referrals={referrals}
          deleteReferralHandler={deleteReferralHandler}
          editAnchorHandler={editAnchorHandler}
          getNewLink={getNewLink}
          onCommentChange={onCommentChange}
        />
      </ShowContainer>
    </CusPageContainer>
  );
}
